import React, { useState, useEffect, useRef } from "react";
import Draggable from "react-draggable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWindowMinimize,
  faWindowMaximize,
} from "@fortawesome/free-solid-svg-icons";
import termsData from "../data/termsData.json";
import "../styles/terms.css";

const Terms = () => {
  const [isMinimized, setIsMinimized] = useState(false);
  const [term, setTerm] = useState(null);
  const nodeRef = useRef(null);

  useEffect(() => {
    console.log("Popup window loaded");
    updateTerm(); // Initial term update
    const interval = setInterval(updateTerm, 30000); // Update term every 30 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const updateTerm = () => {
    const randomCategoryIndex = Math.floor(Math.random() * termsData.length);
    const selectedCategory = termsData[randomCategoryIndex];
    const randomTermIndex = Math.floor(
      Math.random() * selectedCategory.terms.length
    );
    const selectedTerm = selectedCategory.terms[randomTermIndex];
    setTerm(selectedTerm);
  };

  return (
    <Draggable handle=".window-controls" nodeRef={nodeRef}>
      <div
        ref={nodeRef}
        className={`popup-window ${isMinimized ? "minimized" : ""}`}
      >
        <div className="window-controls">
          <FontAwesomeIcon
            icon={isMinimized ? faWindowMaximize : faWindowMinimize}
            onClick={() => setIsMinimized(!isMinimized)}
            className="window-icon"
          />
        </div>
        {!isMinimized && term && (
          <div className="popup-content">
            <p className="td-question">{term.question}</p>
            <p className="td-answer">{term.answer}</p>
          </div>
        )}
      </div>
    </Draggable>
  );
};

export default Terms;
